export default {
  PRIVATE: 'privado',
  PUBLIC: 'publico',
};
